<template>
    <div class="row">
        <div class="col-md-3 custom-sidebar py-5">
                <h4 class="side-navbar-title mb-4">Users</h4>
                <div class="panel-group side-navbar">
                    <a href="#" target="_self" class="nav-link" :class="{ active: tabIndexRFParent == 0 }"
                        @click.stop="open_item_selected(0)">Users</a>

                    <a href="#" target="_self" class="nav-link" :class="{ active: tabIndexRFParent == 1 }"
                        @click.stop="open_item_selected(1)">Roles</a>
                </div>
            </div>
        <div class="col-md-9 pr-0">
            <div class="users-style" >
                <b-alert show dismissible fade v-if='successmsg'>{{successmsg}}</b-alert>
                <h4 class="atlhr-dashboard-title mt-10 pl-3 pb-3">Agent Users<span><a v-bind:href="$api_url+'/company'">Dashboard</a> / Agent Users</span></h4>
                <div class="regulatory-filing-tab payroll-reporting-tab col-md-12">
                    <b-tabs pills content-class="" nav-class=" pr-2 m-2" nav-wrapper-class="col-md-12 custom-tab-nav custom-margin ml-auto pl-0 bg-white d-none" v-model="tabIndexRFParent">
                        <b-tab @click="getRoles">
                            <template active v-slot:title>Users</template>
                            <div class="row no-gutters py-2 mb-3 reports-tab-nav mt-2">
                                <div class="col-sm-6 pl-0 company-form-box-title pt-4">
                                    <div class="custom-search">
                                        <b-input-group class="mb-2">
                                            <b-input-group-prepend is-text>
                                                <b-icon icon="search"></b-icon>
                                            </b-input-group-prepend>
                                            <b-form-input type="search" placeholder="Search Agent User" v-model="search" @input="resetPagination()"></b-form-input>
                                        </b-input-group>
                                    </div>
                                </div>
                                <div class="col-sm-6 pr-0 cursor-pointer text-right company-form-box-title pt-4">
                                    <!--<a :href="this.$api_url+'/agent/team-allocation'">Team Allocation</a>-->
                                    <b-button @click="showTeamAllocation()" class="btn-primary custom-wizard-btn"><b-icon icon="diagram3" ></b-icon> Team Allocation</b-button>
                                    <b-button @click="addNew()"><b-icon icon="plus" ></b-icon> New Agent User</b-button>
                                </div>
                                <table class="table dataTable">
                                    <thead>
                                        <!--<tr class="table-head">
                                            <td>Name</td>
                                            <td>Email</td>
                                            <td>Phone</td>
                                            <td>Access Assigned</td>
                                            <td>Access Level</td>
                                            <td>Status</td>
                                            <td class="float-right">Action</td>
                                        </tr>-->

                                        <tr class="table-head">
                                            <th v-for="column in columns" :key="column.name" @click="sortBy(column.name)":class="sortKey === column.name ? (sortOrders[column.name] > 0 ? 'sorting_asc' : 'sorting_desc') : 'sorting'" style="cursor:pointer;"><span>{{column.label}}</span></th>
                                            <th class="text-right">Actions</th>
                                        </tr>
                                    </thead>

                                    <tbody>
                                        <tr class="hover-bg table-row border-bottom mx-2" v-for="user in paginatedData" :key="user.id">
                                            <td>{{user.name}}</td>
                                            <td>{{user.email}}</td>
                                            <td><template v-if="user.phone">{{formatPhoneNumber(user.phone)}}</template></td>
                                            <!--<td>{{assigned[user.assigned].text}}</td>-->
                                            <td>{{show_user_level[user.user_level].text}} <template v-if="user.rootuser == 1">*</template></td>
                                            <td>{{roles[user.role_id]}}</td>
                                            <td>{{status[user.status].text}}</td>
                                            <td class="float-right">
                                                <div class="position-relative">
                                                    <b-button-toolbar>
                                                        <a id="actionDropdown" class="dropdown-toggle clearfix action-dropdown-toggle" style="font-size: 16px;" href="#" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"><b-icon icon="three-dots-vertical"></b-icon></a>
                                                        <div class="dropdown-menu action-dropdown-menu" aria-labelledby="actionDropdown">
                                                            <b-button-group >
                                                                <b-button variant="outline-secondary"  @click="editUserAgent(user.user_id)">
                                                                    <b-icon icon="pencil"></b-icon> Edit
                                                                </b-button>
                                                            </b-button-group>
                                                        </div>
                                                    </b-button-toolbar>
                                                </div>
                                            </td>
                                        </tr>
                                        <tr v-if="paginatedData.length > 0"><td :colspan="6">
                                        <div class="row p-2 float-right" >
                                            <b-pagination-nav  v-model="pagination.currentPage" :number-of-pages="pagination.pages" base-url="#" first-number last-number ></b-pagination-nav>
                                        </div></td></tr>
                                        <tr v-if="paginatedData.length == 0"><td :colspan="6">{{blankmsg}}</td></tr>
                                    </tbody>
                                </table>
                            </div>


                            <b-modal id="bv-modal-team-allocation" dialog-class="modal-xxl modal-overflow" body-class="pt-0" header-class="mb-2" size="lg" hide-footer title="Team Allocation">
                                <agent-team-allocation ></agent-team-allocation>
                            </b-modal>
                            <b-modal id="bv-modal-example" size="lg" hide-footer title="Agent User">
                                <div class="custom-loader-wrapper" v-if="loader">
                                    <div class="text-center">
                                        <img v-bind:src="$api_url+'/images/download-loader.svg'" class="loader-logo" width="100px"/>
                                    </div>
                                </div>
                                <ul>
                                    <li clase="text-uppercase" v-for='data in errormsg'>{{data[0]}}</li>
                                </ul>
                                <b-overlay :show="showoverlay" rounded="sm">
                                    <b-form @submit.stop.prevent="onSubmit">
                                        <input type="hidden" v-model="fdata.id" name="id">

                                        <b-form-group id="name-group" label="Name" class="half-width mr1" label-for="name">
                                            <b-form-input id="name" name="name" v-model="fdata.name" v-validate="{ required: true, min: 3 }" :state="validateState('name')" aria-describedby="name-feedback" data-vv-as="Name"></b-form-input>
                                            <b-form-invalid-feedback id="name-feedback">{{ veeErrors.first('name') }}</b-form-invalid-feedback>
                                        </b-form-group>

                                        <b-form-group id="email-group" label="Email" class="half-width" label-for="email">
                                            <b-form-input id="email" name="email" type="email" v-model="fdata.email" v-validate="{ required: true, min: 3 , email:true}" :state="validateState('email')" aria-describedby="email-feedback" data-vv-as="Email"></b-form-input>
                                            <b-form-invalid-feedback id="email-feedback">{{ veeErrors.first('email') }}</b-form-invalid-feedback>
                                        </b-form-group>

                                        <b-form-group id="phone-group" label="Phone" class="required-field half-width mr1" label-for="phone">
                                            <b-input-group prepend="+880">
                                                <b-form-input id="phone" name="phone" v-model="fdata.phone" v-validate="{ required: true, min: 10 , max:10 }" :state="validateState('phone')" aria-describedby="phone-feedback" data-vv-as="Contact Number"></b-form-input>
                                                <b-form-invalid-feedback id="phone-feedback">{{ veeErrors.first('phone') }}</b-form-invalid-feedback>
                                            </b-input-group>
                                        </b-form-group>

                                        <!--<b-form-group id="assigned-group" label="Access Assigned" label-for="assigned">
                                            <b-form-select id="assigned" name="assigned" v-model="fdata.assigned" v-validate="{ required: true }" :options="assigned" :state="validateState('assigned')" aria-describedby="level-feedback" data-vv-as="Access Asigned"></b-form-select>
                                            <b-form-invalid-feedback id="assigned-feedback">{{ veeErrors.first('assigned') }}</b-form-invalid-feedback>
                                        </b-form-group>-->

                                        <b-form-group id="user_level-group" class="half-width" label="Access Level" label-for="user_level" v-if="fdata.rootuser != 1">
                                            <b-form-select id="user_level" name="user_level" v-model="fdata.user_level" v-validate="{ required: true }" :options="user_level" :state="validateState('user_level')" aria-describedby="user_level-feedback" data-vv-as="Access Level"></b-form-select>
                                            <b-form-invalid-feedback id="user_level-feedback">{{ veeErrors.first('user_level') }}</b-form-invalid-feedback>
                                        </b-form-group>

                                        <b-form-group id="role_id-group" class="half-width mr1" label="Role" label-for="role_id">
                                            <b-form-select id="role_id" name="role_id" v-model="fdata.role_id" v-validate="{ required: true }" :options="roles" :state="validateState('role_id')" aria-describedby="role_id-feedback" data-vv-as="Role"></b-form-select>
                                            <b-form-invalid-feedback id="role_id-feedback">{{ veeErrors.first('role_id') }}</b-form-invalid-feedback>
                                        </b-form-group>



                                        <b-form-group id="assigned_companies-group" class="half-width " label="Assigned Companies" label-for="assigned_companies" v-if="fdata.user_level > 2">
                                            <b-form-checkbox-group stacked
                                                v-model="fdata.assigned_companies"
                                                :options="companies"
                                                id="assigned_companies" name="assigned_companies"
                                            ></b-form-checkbox-group>
                                        </b-form-group>

                                        <b-form-group id="status-group" label="Status" class="half-width mr1" label-for="status" v-if="fdata.rootuser != 1">
                                            <b-form-select id="status" name="status" v-model="fdata.status" v-validate="{ required: true }" :options="status" :state="validateState('status')" aria-describedby="status-feedback" data-vv-as="Status"></b-form-select>
                                            <b-form-invalid-feedback id="status-feedback">{{ veeErrors.first('status') }}</b-form-invalid-feedback>
                                        </b-form-group>

                                        <b-form-group id="status-group"  class="full-width mr1">

                                            <div class="text-center mt-3">
                                                <b-button class="ml-2 btn-primary custom-wizard-btn" variant="success" @click="resetForm()">Reset</b-button>
                                                <b-button class="btn-primary" type="submit" variant="success">Submit</b-button>
                                            </div>

                                        </b-form-group>

                                        <div class="d-none">
                                            <b-form-group id="change_password-group" class="half-width mr1" label-for="change_password" v-if="edit_user">
                                                <b-form-checkbox id="change_password"  v-model="fdata.change_password" name="change_password" value="change_password">
                                                    Change Password
                                                </b-form-checkbox>
                                            </b-form-group>

                                            <b-form-group id="password-group" label="Password" class="half-width mr1" label-for="password" v-if="fdata.change_password">
                                                <b-form-input id="password" name="password" type="password" v-model="fdata.password" v-validate="{ required: true, min: 8 }" :state="validateState('password')" aria-describedby="password-feedback" data-vv-as="Password"></b-form-input>
                                                <b-form-invalid-feedback id="password-feedback">{{ veeErrors.first('password') }}</b-form-invalid-feedback>
                                            </b-form-group>

                                            <b-form-group id="password_confirmation-group" class="half-width" label="Confirm Password" label-for="password_confirmation" v-if="fdata.change_password">
                                                <b-form-input id="password_confirmation" name="password_confirmation" type="password" v-model="fdata.password_confirmation" v-validate="{ required: true, confirmed: fdata.password }" :state="validateState('password_confirmation')" aria-describedby="password_confirmation-feedback" data-vv-as="Confirm Password"></b-form-input>
                                                <b-form-invalid-feedback id="password_confirmation-feedback">{{ veeErrors.first('password_confirmation') }}</b-form-invalid-feedback>
                                            </b-form-group>
                                        </div>

                                    </b-form>
                                </b-overlay>
                            </b-modal>



                        </b-tab>
                        <b-tab lazy>
                            <template active v-slot:title>Roles</template>
                            <roles-agent ></roles-agent>
                        </b-tab>
                    </b-tabs>
                </div>













            </div>
        </div>
    </div>
</template>


<script>
    export default{

        mounted() {
            //console.log('Bank info started..');
            //console.log(this.employee_id);
        },
        props: [],
        data(){

            let sortOrders = {};
            let columns = [
                            {label: 'Name', name: 'name' },
                            {label: 'Email', name: 'email'},
                            {label: 'Phone', name: 'phone'},
                            {label: 'Access Level', name: 'user_level'},
                            {label: 'Role', name: 'role_id'},
                            {label: 'Status', name: 'status'},
                        ];
            columns.forEach((column) => {sortOrders[column.name] = -1;});

            return {
                disableme : false,
                users : [],
                companies : [],
                successmsg : null,
                errormsg : [],
                showoverlay : false,
                fdata: {status:null , id:null , user_level:null , assigned:'1' , password:'pass1234' , password_confirmation:'pass1234', change_password:true , assigned_companies : []},
                edit_user : false,
                blankmsg : 'Fetching data..',
                search : '',
                loader : false,

                columns: columns,
                sortKey: 'name',
                sortOrders: sortOrders,
                length : 50,
                pagination : {currentPage: 1,total: '',nextPage: '',prevPage: '',from: '',to: '', pages:1},

                status: [
                    { value: null, text: "Select..." },
                    { value: "1", text: "Active" },
                    { value: "2", text: "Pending" },
                    { value: "3", text: "Not Approved" },
                    { value: "4", text: "Other" },
                ],
                user_level: [
                    { value: null, text: "Select..." },
                    { value: "2", text: "Admin" },
                    { value: "3", text: "Manager" },
                    { value: "4", text: "Officer" },
                ],
                assigned: [
                    { value: "0", text: "No" },
                    { value: "1", text: "Yes" },

                ],
                show_user_level: [
                    { value: "0", text: "Select..." },
                    { value: "1", text: "Select..." },
                    { value: "2", text: "Admin" },
                    { value: "3", text: "Manager" },
                    { value: "4", text: "Officer" },
                ],

                roles:[],
                tabIndexRFParent: 0,


            }
        },
        methods:{
            open_item_selected: function (item) {
                this.tabIndexRFParent = item;
            },
            getRoles: function()
            {
                if(!this.checkNet()) return false;
                let currentObj = this;
                axios.get(this.$api_url+'/acl/role/options/agent' , {
                    params: {

                    }
                }).then(function(response){
                    this.roles = response.data;

                }.bind(this)).catch(function (error){
                    //currentObj.serverError(error);
                    });
            },
            getAgentUsers: function()
            {
                if(!this.checkNet()) return false;
                axios.get(this.$api_url+'/agent/userlist' , {
                    params: {
                        //employee_id: this.employeeId
                    }
                }).then(function(response){
                    //console.log(response.data);
                    this.users = response.data;
                    if(this.users.length == 0)
                        this.blankmsg = "Nothing found.";

                    else
                        this.sortBy('name');

                }.bind(this)).catch(function (error){this.serverError(error);});
            },
            editUserAgent:function(x)
            {
                if(!this.checkNet()) return false;
                let currentObj = this;

                axios.get(this.$api_url+'/agent/user' , {
                    params: {
                        id: x
                    }
                }).then(function(response){
                    this.fdata = response.data;
                    this.fdata.phone = response.data.phone.slice(3,15);
                    this.disableme = true;
                    this.$validator.reset();
                    this.edit_user = true;
                    this.successmsg = null;
                }.bind(this)).catch(function (error){currentObj.serverError(error);});

                this.$bvModal.show('bv-modal-example');
            },
            validateState(ref)
            {
                if (
                    this.veeFields[ref] &&
                    (this.veeFields[ref].dirty || this.veeFields[ref].validated)
                ) {
                    return !this.veeErrors.has(ref);
                }
                return null;
            },
            resetForm()
            {
                this.fdata = {name:null, status:null, user_level:null, email:null, id:null, phone:null,assigned:1, password:'pass1234' , password_confirmation:'pass1234'};
                this.disableme = false;
                this.$nextTick(() => {
                    this.$validator.reset();
                });

                this.errormsg = [];
            },
            addNew()
            {
                this.resetForm();
                this.edit_user = false;
                this.disableme = false;
                this.fdata.change_password = true;
                this.$bvModal.show('bv-modal-example');
            },
            showTeamAllocation()
            {
                this.$bvModal.show('bv-modal-team-allocation');
            },
            getCompanies: function(){
              axios.get(this.$api_url+'/agent/company/list')
              .then(function (response) {
                    console.log(response.data);
                    //this.companies = [{ value: 0, text: "Select..." } ] . concat(response.data);
                    this.companies = response.data;
              }.bind(this));

            },
            onSubmit(e)
            {
                if(!this.checkNet()) return false;
                this.$validator.validateAll().then(result => {
                    if (!result) {
                        return;
                    }
                    this.showoverlay = false;
                    this.loader = true;
                    e.preventDefault();
                    let currentObj = this;
                    const config = {
                        headers: { 'content-type': 'multipart/form-data' }
                    }

                    let formData = new FormData();

                    for (let [key, value] of Object.entries(this.fdata))
                    {
                        var nm = `${key}`;
                        var fval = `${value}`;
                        formData.append(nm, fval);
                        //console.log(`${key}: ${value}`);
                    }

                    axios.post(this.$api_url+'/agent/saveuser', formData, config)
                                .then(function (response)
                                {
                                    //console.log(response.data);
                                    this.users = response.data;

                                    this.showoverlay = false;
                                    this.loader = false;

                                    this.$bvToast.toast('Saved!', {
                                            title: `Success`,
                                            variant: 'success',
                                            solid: true
                                        });

                                    this.$bvModal.hide('bv-modal-example');
                                    this.resetForm();

                                }.bind(this))
                                .catch(function (error)
                                {
                                    currentObj.serverError(error);
                                    currentObj.errormsg = error.response.data.errors;
                                    currentObj.showoverlay = false;
                                    currentObj.loader = false;
                                });
                });
            },

        },
        created: function(){
            this.getAgentUsers();
            this.getRoles();
            this.getCompanies();
            Fire.$on('reloadUsers', () => {this.getAgentUsers()})
        },
        computed:
        {
            filteredData()
            {
                let filtered_list = this.users;
                if (this.search)
                {
                    filtered_list = filtered_list.filter((row) => {return Object.keys(row).some((key) => {return String(row[key]).toLowerCase().indexOf(this.search.toLowerCase()) > -1;})});

                    if(filtered_list.length == 0)
                        this.blankmsg = "Nothing found.";
                }

                let sortKey = this.sortKey;
                let order = this.sortOrders[sortKey] || 1;
                if (sortKey)
                {
                    filtered_list = filtered_list.slice().sort((a, b) => {let index = this.getIndex(this.columns, 'name', sortKey);
                            a = String(a[sortKey]).toLowerCase();
                            b = String(b[sortKey]).toLowerCase();
                            if (this.columns[index].type && this.columns[index].type === 'date')
                            {
                                return (a === b ? 0 : new Date(a).getTime() > new Date(b).getTime() ? 1 : -1) * order;
                            }
                            else if (this.columns[index].type && this.columns[index].type === 'number')
                            {
                                return (+a === +b ? 0 : +a > +b ? 1 : -1) * order;
                            }
                            else
                            {
                                return (a === b ? 0 : a > b ? 1 : -1) * order;
                            }
                        }
                    );
                }

                return filtered_list;
            },
            paginatedData()
            {
                return this.paginate(this.filteredData, this.length, this.pagination.currentPage);
            }
        }
    }
</script>
